export default {
  SET_SUPPORT_SETTINGS(state, results) {
    state.supportSettings = results;
  }
};
